import { render } from "./todoList.vue?vue&type=template&id=4add5dab&scoped=true"
import script from "./todoList.vue?vue&type=script&lang=js"
export * from "./todoList.vue?vue&type=script&lang=js"

import "./todoList.vue?vue&type=style&index=0&id=4add5dab&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4add5dab"

export default script